import cn from 'classnames'

export const Label = ({ children, htmlFor, className }) => (
  <label htmlFor={htmlFor} className={cn('block mb-2 font-bold', className)}>
    {children}
  </label>
)
